import type React from 'react';
import type { ForwardedRef } from 'react';
import { useCallback, useEffect, useState } from 'react';

export default function useScrollTranslation(
    containerRef: React.RefObject<HTMLDivElement | null> | ForwardedRef<HTMLTableRowElement>,
): {
    translationX: number;
    translationY: number;
} {
    const [{ scrollLeft, scrollTop }, setScroll] = useState({ scrollLeft: 0, scrollTop: 0 });
    const element = containerRef && 'current' in containerRef ? containerRef.current : null;

    const handleScroll = useCallback(() => {
        if (element !== null) setScroll({ scrollLeft: element.scrollLeft, scrollTop: element.scrollTop });
    }, [element]);

    useEffect(() => {
        if (element !== null) element.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            if (element !== null) element.removeEventListener('scroll', handleScroll);
        };
    }, [element, handleScroll]);

    return { translationX: -scrollLeft, translationY: -scrollTop };
}
